import { ReactElement } from 'react';
import { Component as GroceryBagIcon } from 'icons/icon--grocery-bag.svg';
import { Component as RecipeCardIcon } from 'icons/icon-mktg--recipe.svg';
import { Component as PlantCheckIcon } from 'icons/icon-ui--plant-check.svg';
import { WhatToKnow } from '../../order-confirmation/WhatToKnow';

export function SubscriptionBenefits(): ReactElement {
  const sections = [
    {
      title: 'A plant-based offering for every occasion.',
      body: 'Meal kits for family dinners, prepared meals for school and work, pantry staples for in-between.',
      icon: <GroceryBagIcon height={40} width={35} />,
    },
    {
      title: 'New menus and chef-crafted recipes every week.',
      body: 'The menu changes weekly with each delivery - no more repetitive dinners.',
      icon: <RecipeCardIcon height={40} width={35} />,
    },
    {
      title: 'Skip, pause, or cancel anytime; no commitment required.',
      body: 'Our service is flexible - opt-out any week you already have meals handled.',
      icon: <PlantCheckIcon height={40} width={35} />,
    },
  ];

  return (
    <WhatToKnow
      header="All your plant-based eating, delivered weekly, in one place."
      sections={sections}
      isVertical
      useSmallSizing
    />
  );
}
